import { render, staticRenderFns } from "./yfk.vue?vue&type=template&id=504bfdc6&scoped=true&"
import script from "./yfk.vue?vue&type=script&lang=js&"
export * from "./yfk.vue?vue&type=script&lang=js&"
import style0 from "./yfk.vue?vue&type=style&index=0&id=504bfdc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504bfdc6",
  null
  
)

export default component.exports